/**
 * A returnUrl is "safe" only when it's a same-origin relative path:
 * starts with a single `/`, and isn't a protocol-relative (`//`) or
 * backslash-escaped (`/\`) URL that browsers may resolve cross-origin.
 *
 * Used to guard against open-redirect attacks anywhere we navigate the
 * SPA to a caller-supplied path (sign-in flow callback, etc.).
 */
export function isSafeRelativePath(value: unknown): value is string {
  return (
    typeof value === 'string' &&
    value.startsWith('/') &&
    !value.startsWith('//') &&
    !value.startsWith('/\\')
  );
}
